module.exports = __webpack_public_path__ + "img/55.e3d072ca.jpg";